import React from 'react'
import "../styles/footer.scss"
import logo from "../assets/icone/logo_vett_b.svg"
import casa_it from "../assets/icone/casa_it.svg";
import immobiliare from "../assets/icone/immobiliare.svg";
import idealista from "../assets/icone/idealista.svg";

export default function Footer() {
  return (
    <div className='footer'>
        <div className='inner_footer max-w'>

            <div className='container_elementi_footer'>
                <img className='logo_footer' src={logo} />
                <div className='testo_footer'>
                    BLEND è un marchio di <br />STUDIO AUREA SRL<br />
                    sede legale Via Treccani degli Alfieri, 22 - 20141 Milano (MI) | Capitale sociale € 10.000,00 i.v. | P.Iva/C.F. 12005790964
                </div>
            </div>

            <div className='elementi_logo_footer_container'>
                <a className='link_footer' target='_blank' href="https://www.casa.it/agenzie/studio-aurea-1210277/">
                <div className='elem_footer_logo'>
                    <div className='elemento_logo_footer'><img src={casa_it} className='logo_cerchi_casa'/></div>
                    <div className='elemento_scritta_footer'>Casa.it</div>
                </div>
                </a>

                <a className='link_footer' target='_blank' href="https://www.idealista.it/pro/studio-aurea/">
                <div className='elem_footer_logo'>
                    <div className='elemento_logo_footer'><img src={idealista} className='logo_cerchi_casa'/></div>
                    <div className='elemento_scritta_footer'>Idealista</div>
                </div>
                </a>
                
                <a className='link_footer' target='_blank' href="https://www.immobiliare.it/agenzie-immobiliari/383482/studio-aurea-opera/">
                <div className='elem_footer_logo'>
                    <div className='elemento_logo_footer'><img src={immobiliare} className='logo_cerchi_casa'/></div>
                    <div className='elemento_scritta_footer'>Immobiliare.it</div>
                </div>
                </a>
            </div>

            <div className='link_privacy_footer'>
                <a href="https://www.iubenda.com/privacy-policy/38587774" className="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy ">Privacy Policy</a><script type="text/javascript">{(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document)}</script>
                <a href="https://www.iubenda.com/privacy-policy/38587774/cookie-policy" className="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Cookie Policy ">Cookie Policy</a><script type="text/javascript">{(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document)}</script>
            </div>

            
        </div>
    </div>
  )
}
